
const handleOverlay = (overlay) => {
  let closeButton = overlay.querySelector('.close-btn');
  overlay.addEventListener('click', e => {
    // Click away from modal or click close button, close overlay
    if (!e.target.closest('.modal') || e.target == closeButton){
      overlay.classList.remove('active');
      handleFixedElements('show');
      // If overlay has video, pause video on close
      if(overlay.classList.contains('video-overlay') || overlay.classList.contains('product-overview-video-overlay')) {
        let video = overlay.querySelector('video');
        video.pause();
      }
    }
  });
}

// Call for all loaded overlays
let overlays = document.querySelectorAll('.overlay').forEach((overlay) => handleOverlay(overlay));
